import { createDataHooks, createDriver } from '@wix/premium-fed-sdk/test-utils';
export const DATA_HOOKS = createDataHooks('check-list', 'item');
export const checkListViewDriver = createDriver(DATA_HOOKS);
//# sourceMappingURL=CheckListView.driver.js.map